module.exports = __webpack_public_path__ + "static/img/stay-option-icon-kids.9699fd6e.svg";